module.exports = __webpack_public_path__ + "img/banner_right2.26e1f4df.png";